<div class="sale-consignor-list-result">
  <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-md mt-3 p-0" #tableConsignor>
    <table mat-table="matTable"
           [dataSource]="dataSource"
           #matTable
           class="table table-hover"
           infiniteScroll
           [infiniteScrollDistance]="1"
           [infiniteScrollThrottle]="20"
           [infiniteScrollContainer]="tableConsignor"
           [fromRoot]="true"
           (scrolled)="onTableScroll()"
           [trackBy]="trackById" matSort="consignorSort">
      <ng-container matColumnDef="checkbox">
        <th scope="col"
            class="checkbox-heading" style="width:5%"
            mat-header-cell
            *matHeaderCellDef>
          <div class="custom-control custom-checkbox custom-checkbox-lg blank-label">
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
            <label class="custom-control-label custom-control-label-all"
                   for="allCheckbox"></label>
          </div>
        </th>
        <td *matCellDef="let element; let saleHorseIndex = index">
          <div class="custom-control custom-checkbox custom-checkbox-lg blank-label ps-3">
            <mat-checkbox [disabled]="!element.consignorContact"
                          (change)="onSingleChange($event,element)" [checked]="selection.isSelected(element)">
            </mat-checkbox>
            <label class="custom-control-label"
                   for="blankCheckbox-{{ saleHorseIndex }}"></label>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="businessName">
        <th mat-header-cell mat-sort-header
            class="consignor-heading cursor-pointer" style="width:15%"
            *matHeaderCellDef>
          consignor <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.businessName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="consignorContact">
        <th mat-header-cell mat-sort-header
            class="contact-heading cursor-pointer" style="width:35%"
            *matHeaderCellDef>
          Contacts <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          <div [innerHTML]="element.consignorContact"></div>
        </td>
      </ng-container>

      <!--<ng-container matColumnDef="emailId">
      <th
        mat-header-cell
        class="email-heading w-8-rem cursor-pointer"
        *matHeaderCellDef
        (click)="sortTable(saleConsignorTableFields.EMAIL_ID)"
      >
        Email <i class="fa fa-sort ms-1"></i>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.emailId }}
      </td>
    </ng-container>-->

      <ng-container matColumnDef="horsesInSale">
        <th mat-header-cell mat-sort-header
            class="horses-in-sale-heading cursor-pointer" style="width:11%"
            *matHeaderCellDef>
          Horses <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="less-height-2-rem text-left">
          <div>{{ element.activeCount }} Active</div>
          <div>{{ element.withdrawnCount }} Withdrawn</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="xrayCount">
        <th mat-header-cell
            class="xrays-submitted-count-heading cursor-pointer" style="width:8%"
            *matHeaderCellDef mat-sort-header>
          X-RAYS APPROVED <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="count-column-align fw-bold ps-5"
            [class.text-danger]="!element.isXraySubmissionDone">
          {{ element.xrayCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="scopeCount">
        <th mat-header-cell
            class="scope-video-submitted-count-heading cursor-pointer" style="width:8%"
            *matHeaderCellDef mat-sort-header>
          SCOPE APPROVED <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="count-column-align fw-bold ps-5"
            [class.text-danger]="!element.isScopeSubmissionDone">
          {{ element.scopeCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="xrayReportCount">
        <th mat-header-cell
            class="x-ray-report-count-heading cursor-pointer" style="width:8%"
            *matHeaderCellDef mat-sort-header>
          X-RAY REPORT APPROVED <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="count-column-align fw-bold ps-5"
            [class.text-danger]="!element.isXrayReportSubmissionDone">
          {{ element.xrayReportCount }}
        </td>
      </ng-container>
      <ng-container matColumnDef="link" *ngIf="!isVet">
        <th mat-header-cell class="link-heading" style="width:10%" *matHeaderCellDef>
          Action
        </th>
        <td mat-cell *matCellDef="let element" ngbDropdown placement="start">
          <a class="btn btn-outline-primary btn-sm me-1"
             *ngIf="isSalesCompany"
             (click)="openConsignorContactPopup(element)"
             title="Edit Contacts">
            <i class="far fa-edit"></i>
          </a>
          <span class="divider"></span>
          <a href="{{ appendShareLinkPrefix(element.consignorDownloadLink) }}"
             target="_blank"
             class="btn btn-outline-primary btn-sm btn-view"
             title="Share">
            <i class="fa fa-share-square"></i>
          </a>
        </td>
      </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
        <tr mat-row
            *matRowDef="
          let row;
          columns: displayedColumns$.value;
          let saleIndex = index
        "
            class="border-start-0 border-end-0 pointer pt-2"></tr>
    </table>

    <!--<div class="row" *ngIf="isLoaderSaleConsignors">
      <div class="col-md-12 text-center">
        Loading <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>-->
    <!--<app-consignor-contact-popup (onSave)="handleContactSave()"></app-consignor-contact-popup>-->


  </div>
</div>
